export default "__VITE_ASSET__VxSkYexe__"